"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8650],{

/***/ 28650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VideoEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 56.25%;\n  position: relative;\n  width: 100%;\n\n  > iframe {\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function VideoEmbed(param) {
    var url = param.url;
    var src = function() {
        var videoId = url.substring(url.lastIndexOf("/") + 1);
        if (url.includes("vimeo.com")) {
            return "https://player.vimeo.com/video/".concat(videoId);
        }
        if (url.includes("youtube.com")) {
            videoId = url.substring(url.lastIndexOf("=") + 1);
        }
        return "https://www.youtube.com/embed/".concat(videoId);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IframeContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
            src: src(),
            frameBorder: "0",
            allowFullScreen: true
        })
    });
}
var IframeContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject());


/***/ })

}]);